<template>
  <!-- 数据审核流程 -->
  <div class="checkDiv">
    <div>
      <div class="line1">
        <div>
          <span>状态：</span>
          <b>
            <a-tag v-if="formData.checkStatus === 0">未审核</a-tag>
            <a-tag v-if="formData.checkStatus === 1" color="cyan">审核中</a-tag>
            <a-tag v-if="formData.checkStatus === 2" color="green">审核通过</a-tag>
            <a-tag v-if="formData.checkStatus === 3" color="red">审核不通过</a-tag>
          </b>
        </div>
        <div>
          <a-button icon="eye" type="primary" @click="historyDataClick()">查看历史数据</a-button>
        </div>
      </div>
      <a-row style="margin:20px 0;">
        <span style="width:80px; font-weight:bold;">审核流程:</span>
        <a-col :span="24" style="display:flex; align-items: center; margin-top: 20px;">
          <!-- <b style="color:rgb(69 183 93);"> {{auditProcess}}</b> -->
          <!-- <public-check-data :row-data="auditDataList" /> -->
          <a-timeline style="width: 100%;">
            <a-timeline-item v-for="(item,index) in auditDataList" :key="index">
              <b v-if="item.condition===0">普通:</b>
              <b v-if="item.condition===1">会签:</b>
              <b v-if="item.condition===2">或签:</b>
              <span
                class="nameClass"
                :class="getClass(item2.processorCerType)"
                v-for="(item2, index2) in item.processorCerVoList"
                :key="index2"
                style="margin-left:8px;"
              >{{item2.processorCerName}}</span>

              <div v-if="checkRecordList && checkRecordList[index]">
                <!--<div v-for="(item, index) in checkRecordList" :key="index">-->
                <a-row
                  v-if="checkRecordList[index].checkStatus === 2 || checkRecordList[index].checkStatus === 3"
                  class="checkDetailsDiv"
                  style="text-align:center;"
                >
                  <a-col :span="6">审 批 人：{{ checkRecordList[index].creator }}</a-col>
                  <a-col :span="6" v-if="checkRecordList[index].checkStatus === 2">
                    审批状态：
                    <span style="color: #42b983;">
                      <a-icon type="check-circle" theme="filled" />通过
                    </span>
                  </a-col>
                  <a-col :span="6" v-else-if="checkRecordList[index].checkStatus === 3">
                    审批状态：
                    <span style="color: #faad14;">
                      <a-icon type="close-circle" theme="filled" />未通过
                    </span>
                  </a-col>
                  <a-col :span="10">审批时间：{{ checkRecordList[index].createTime }}</a-col>
                </a-row>
                <a-row
                  v-if="checkRecordList[index].checkStatus === 2 || checkRecordList[index].checkStatus === 3"
                  class="checkDetailsDivd"
                >
                  <a-col :span="4" style="text-align:end">审核意见：</a-col>
                  <a-col :span="20">{{ checkRecordList[index].checkComment }}</a-col>
                </a-row>
                <!-- </div>-->
              </div>
              <div v-else style="height: 50px;">
                <a-divider orientation="center">暂无审核数据</a-divider>
              </div>
            </a-timeline-item>
          </a-timeline>
        </a-col>
      </a-row>
    </div>
    <a-modal
      width="40%"
      v-model="modelVisible"
      title="历史审核数据"
      @ok="modelHandleOk"
      @cancel="modelHandleOk"
    >
      <div
        style="height: 300px; overflow-y: scroll;"
        v-if="modelListData && modelListData.length>0"
      >
        <div v-for="(item, index) in modelListData" :key="index">
          <a-row
            v-if="item.checkStatus === 2 || item.checkStatus === 3"
            class="checkDetailsDiv"
            style="text-align:center;"
          >
            <a-col :span="6">审 批 人：{{ item.creator }}</a-col>
            <a-col :span="6" v-if="item.checkStatus === 2">
              审批状态：
              <span style="color: #42b983;">
                <a-icon type="check-circle" theme="filled" />通过
              </span>
            </a-col>
            <a-col :span="6" v-else-if="item.checkStatus === 3">
              审批状态：
              <span style="color: #faad14;">
                <a-icon type="close-circle" theme="filled" />未通过
              </span>
            </a-col>
            <a-col :span="10">审批时间：{{ item.createTime }}</a-col>
          </a-row>
          <a-row v-if="item.checkStatus === 2 || item.checkStatus === 3" class="checkDetailsDivd">
            <a-col :span="4" style="text-align:end">审核意见：</a-col>
            <a-col :span="20">{{ item.checkComment }}</a-col>
          </a-row>
          <a-divider v-if="item.checkStatus === 5">重新提交审核</a-divider>
        </div>
      </div>
      <div v-else style="height: 50px;">
        <a-divider orientation="center">暂无历史审核数据</a-divider>
      </div>
    </a-modal>
  </div>
</template>

<script>
import publicCheckData from '@/views/common/historyAduiProcess.vue'
export default {
  name: 'auditProcess',
  components: { publicCheckData },
  data () {
    return {
      checkRecordList: [],
      auditProcess: '',
      formData: {},
      checkData: [],
      checkTypeList: [],
      auditDataList: [],
      modelVisible: false,
      queryObj: {},
      modelListData: []
    }
  },
  methods: {
    getClass (val) {
      switch (val) {
        case 1:
          return 'personClass'
        case 2:
          return 'roleClass'
        case 3:
          return 'dutyClass'
      }
    },
    historyDataClick () {
      this.$get('/history/list', {
        ...this.queryObj,
        pageSize: -1,
        pageNum: -1
      }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.records
          let arr = []
          if (resData && resData.length > 0) {
            resData.forEach(element => {
              if (element.checkStatus === 2 || element.checkStatus === 3 || element.checkStatus === 5) {
                arr.push(element)
              }
            })
          }
          this.modelListData = arr
          this.modelVisible = true
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    modelHandleOk () {
      this.modelVisible = false
    },
    resetData () {
      this.auditProcess = ''
      this.checkData = []
      this.auditDataList = []
    },
    getData (idVal, statusVal, checkType) {
      // 清空之前的内容
      this.resetData()
      this.formData.checkStatus = statusVal
      // 查询顶部审核流程
      this.getTopData(idVal, checkType)
      // 查询列表审核数据
      this.getCheckRecordData(idVal, checkType)
    },
    getTopData (idVal, checkType) {
      // 根据不同类型审批数据传入不同参数查询审批模板 0费用报销 1采购单 2预支预付 3回款记录/付款计划
      this.$get('/checkDetail/listForProcess', { checkType: checkType, recordId: idVal }).then(res => {
        if (res.data.status === 1) {
          this.auditDataList = []
          const newData = res.data.data.rows
          newData.forEach(t => {
            if (t.processorCerVoList.length > 0 && t.processorCerVoList[0].processorCerName !== null) {
              this.auditDataList.push(t)
            }
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    getCheckRecordData (idVal, checkType) {
      this.queryObj = {
        recordId: idVal,
        checkType: checkType
      }
      // 修改接口增加字段HistoryType(JT)
      this.$get('/history/list', {
        recordId: idVal,
        checkType: checkType,
        historyType: 1,
        pageSize: -1,
        pageNum: -1
      }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.records
          let arr = []
          if (resData && resData.length > 0) {
            resData.forEach(element => {
              if (element.checkStatus === 2 || element.checkStatus === 3) {
                arr.push(element)
              }
            })
          }
          this.checkRecordList = arr
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    setStr (stepName, item) {
      if (this.checkData[stepName]) {
        if (item.conditions === 0) {
          this.checkData[stepName] = item.processorName
        } else if (item.conditions === 1) {
          this.checkData[stepName] = this.checkData[stepName] + ' (+) ' + item.processorName
        } else if (item.conditions === 2) {
          this.checkData[stepName] = this.checkData[stepName] + ' (或) ' + item.processorName
        }
      } else {
        this.checkData[stepName] = item.processorName
      }
    },
    getAuditProcess () {
      let checkStr = ''
      for (const key in this.checkData) {
        if (key === 'step1') {
          checkStr = checkStr + ' ①' + ' ' + this.checkData[key]
        } else if (key === 'step2') {
          checkStr = checkStr + ' ②' + ' ' + this.checkData[key]
        } else if (key === 'step3') {
          checkStr = checkStr + ' ③' + ' ' + this.checkData[key]
        } else if (key === 'step4') {
          checkStr = checkStr + ' ④' + ' ' + this.checkData[key]
        } else if (key === 'step5') {
          checkStr = checkStr + ' ⑤' + ' ' + this.checkData[key]
        }
      }
      this.auditProcess = checkStr
    }
  }

}
</script>

<style scoped>
.checkDiv {
  border: 1px solid #ccc;
  margin: 10px 0;
  padding: 10px;
  height: 300px;
  overflow-y: scroll;
}
.line1 {
  display: flex;
  justify-content: space-between;
}
.checkDetailsDiv {
  padding: 10px 0;
  /* border-bottom: 1px dashed #ccc; */
  display: flex;
  justify-content: space-around;
}
.checkDetailsDivd {
  padding: 10px 0;
  border-bottom: 1px dashed #ccc;
  display: flex;
  justify-content: space-around;
}
.ant-divider-horizontal {
  clear: none;
}
.nameClass {
  font-size: 14px;
  color: #ffffff;
  padding: 6px 4px;
  border-radius: 6px;
}
.personClass {
  background-color: #5585ac;
}
.roleClass {
  background-color: #42b983;
}
.dutyClass {
  background-color: #b37bfd;
}
</style>



// WEBPACK FOOTER //
// src/views/common/auditProcess.vue